import { gql } from "@apollo/client"

export const TOURNAMENT_PLAYER_UPDATE = gql`
  mutation TournamentPlayerUpdate($TournamentPlayerUpdateInput: TournamentPlayerUpdateInput!) {
    TournamentPlayerUpdate(input: $TournamentPlayerUpdateInput) {
      status {
        success
        name
        detail
      }
      rounds
      TournamentPlayer {
        id
        byes
        raceId
        Person {
          id
          avatar
          fullName
          urlAvatar
          code
        }
      }
    }
  }
`
